"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dcCore = require("dc-core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const createEventLogger = (repeat = false) => event => {
  const {
    key,
    type
  } = event;
  if (repeat || !event.repeat) {
    global.console.log({
      type,
      key
    }, {
      event
    });
  }
};
const logEvent = createEventLogger(true);

/**
 * Manage click events and delegate them to FocusRegionProvider
 */
class FocusRegionManager extends _react.PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      focusRegions: null
    };
    this.modalKey = 0;
  }
  componentDidMount() {
    const {
      debug
    } = this.props;
    if (debug) {
      window.addEventListener('focusin', logEvent, false);
      window.addEventListener('blur', logEvent, false);
      window.addEventListener('focus', logEvent, false);
      window.addEventListener('focusout', logEvent, false);
      window.addEventListener('keydown', logEvent, false);
      window.addEventListener('keyup', logEvent, false);
      window.addEventListener('keypress', logEvent, false);
    }
    _dcCore.providers['focus-regions']().then(focusRegions => {
      this.setState({
        focusRegions
      }, () => {
        focusRegions.addHelpListener(this.handleHelpDialog);
        document.addEventListener('keydown', focusRegions.handleKeyboardEvent, false);
        document.addEventListener('keypress', focusRegions.handleKeyboardEvent, false);
        document.addEventListener('keyup', focusRegions.handleKeyboardEvent, false);
      });
    });
  }
  componentWillUnmount() {
    const {
      debug
    } = this.props;
    const {
      focusRegions
    } = this.state;
    document.removeEventListener('keydown', focusRegions.handleKeyboardEvent);
    document.removeEventListener('keypress', focusRegions.handleKeyboardEvent);
    document.removeEventListener('keyup', focusRegions.handleKeyboardEvent);
    if (debug) {
      window.removeEventListener('keydown', logEvent);
      window.removeEventListener('keyup', logEvent);
      window.removeEventListener('keypress', logEvent);
      window.removeEventListener('focusin', logEvent);
      window.removeEventListener('focus', logEvent);
      window.removeEventListener('blur', logEvent);
      window.removeEventListener('focusout', logEvent);
    }
  }
  render() {
    return null;
  }
}
FocusRegionManager.propTypes = {
  debug: _propTypes.default.bool
};
FocusRegionManager.defaultProps = {
  debug: false
};
var _default = FocusRegionManager;
exports.default = _default;